/* eslint-disable */

export enum BusinessCategory {
  BUSINESS_CATEGORY_UNSPECIFIED = "BUSINESS_CATEGORY_UNSPECIFIED",
  BUSINESS_CATEGORY_DEFAULT_BUSINESS = "BUSINESS_CATEGORY_DEFAULT_BUSINESS",
}
